export default [
  require('/home/runner/work/docs.igrant.io/docs.igrant.io/node_modules/infima/dist/css/default/default.css'),
  require('/home/runner/work/docs.igrant.io/docs.igrant.io/node_modules/@docusaurus/theme-classic/lib/prism-include-languages'),
  require('/home/runner/work/docs.igrant.io/docs.igrant.io/node_modules/@docusaurus/theme-classic/lib/nprogress'),
  require('/home/runner/work/docs.igrant.io/docs.igrant.io/src/css/custom.scss'),
  require('/home/runner/work/docs.igrant.io/docs.igrant.io/node_modules/docusaurus-theme-openapi-docs/lib/theme/styles.scss'),
  require('/home/runner/work/docs.igrant.io/docs.igrant.io/src/clientModules/docsearchKeydownGuard.js'),
  require('/home/runner/work/docs.igrant.io/docs.igrant.io/src/clientModules/docsearchDrawerHeader.js'),
];
